import { defineStore } from 'pinia';

interface PageState {
  routeData: any;
  pageDetail?: any;
  isSearchOpen: boolean;
}

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
    pageDetail: null,
    isSearchOpen: false,
  }),
  actions: {
    setIsSearchOpen(type: boolean) {
      this.isSearchOpen = type; // 更新 isSearchOpen 属性
    },
  },
});
